module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADaSURBVDhP7ZKxDcIwEEUTIBMwBGN4imyQXCxlBUQaRAU1g9ClSZEFWICCkhVIYf5PDoQgieKOgi+dZL+7/23JDoYkIjZN0xuLa8XTBMMWdcnzfMnimkzb40qSZJdl2TWO47migGsy9hT1KsQpa1z5XBTFTNlLZOxxBtuwo2/CCRsM1H3mpzSk5qyiTgAHNCrn3HfyhziDW1T0tADGPcCp3XiIHnoZcDfGLJRPFj30Mskp81br/Qf8QgDeshn7vkPSb90wpUSJtXblU/RAJQMi/Osj0iqfokdEogexDKTq7Plu0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/2.png
// module id = 80
// module chunks = 0